import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于每日吃瓜',
              description: '每日吃瓜品牌介绍、声誉与联系方式。专注每日爆料与每日黑料实时更新，吃瓜群众聚集地。',
              url: 'https://ryo7a.com/about',
              isPartOf: {
                '@type': 'WebSite',
                name: '每日吃瓜',
                url: 'https://ryo7a.com/',
              },
            }),
          }}
        />

        <section className="relative min-h-[350px] md:min-h-[400px] flex items-center overflow-hidden">
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(135deg, oklch(0.97 0.015 85) 0%, oklch(0.94 0.06 60) 40%, oklch(0.88 0.08 40) 100%)',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20" />

          <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-10">
            <div className="max-w-[1280px] mx-auto">
              <div className="mb-6">
                <Breadcrumb
                  items={[
                    { label: '首页', path: '/' },
                    { label: '关于我们' },
                  ]}
                />
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-8">
                <div className="lg:w-[58%] flex flex-col gap-5">
                  <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full text-xs font-medium text-primary-600 whitespace-nowrap">
                    <i className="ri-information-line" />
                    品牌故事
                  </span>
                  <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight">
                    关于
                    <br />
                    每日吃瓜
                  </h1>
                </div>
                <div className="lg:w-[42%] flex flex-col gap-4 pt-4 lg:pt-16">
                  <p className="text-base text-foreground-700 leading-relaxed">
                    专注每日爆料与每日黑料实时更新的吃瓜聚集地，
                    以真实、快速、全面为核心理念，为吃瓜群众提供最优质的内容。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <article className="py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20brand%20logo%20style%20illustration%2C%20warm%20minimalist%20design%2C%20watermelon%20and%20news%20elements%2C%20clean%20background%2C%20editorial%20style&width=400&height=200&seq=chigua-about-brand&orientation=landscape"
                  alt="每日吃瓜品牌标识"
                  title="每日吃瓜品牌标识"
                  className="mx-auto w-[200px] h-[100px] object-cover object-top rounded-lg"
                />
              </div>

              <p className="text-xs text-foreground-400 text-center mb-10">
                — 吃瓜，我们是认真的 —
              </p>

              <div className="bg-background-100/70 rounded-2xl p-8 md:p-12">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                  品牌介绍
                </h2>
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                  每日吃瓜成立于2025年，是国内领先的娱乐资讯聚合平台。
                  我们专注每日爆料与每日黑料实时更新，汇聚今日大瓜独家速报、
                  网红翻车实锤与明星八卦等海量娱乐内容。
                </p>
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                  作为免费吃瓜官网入口，每日吃瓜始终坚持"真实、快速、全面"的编辑理念。
                  我们的编辑团队由资深娱乐记者和行业内部人士组成，拥有广泛的圈内人脉
                  和一手信息来源，能够在事件发生的第一时间为读者提供最准确的报道。
                </p>
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                  每日更新不打烊，365天全年无休。无论是深夜突发的明星绯闻，
                  还是周末爆出的网红翻车现场，每日吃瓜总能在第一时间为你奉上最新鲜的大瓜。
                  我们深知，吃瓜不仅是一种娱乐方式，更是一种社交需求——
                  在每日吃瓜，你总能找到和你一样热爱吃瓜的同好。
                </p>
              </div>

              <div className="bg-background-100/70 rounded-2xl p-8 md:p-12 mt-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                  声誉与原则
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-primary-600 text-lg" />
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">真实性原则</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        每一条爆料都经过多方核实，拒绝传播未经证实的虚假信息。
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-speed-up-line text-primary-600 text-lg" />
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">快速响应</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        7x24小时追踪娱乐圈动态，确保你永远第一时间吃到最新鲜的瓜。
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-lock-line text-primary-600 text-lg" />
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">隐私保护</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        严格保护爆料人隐私信息，绝不透露任何消息来源的身份。
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-scales-3-line text-primary-600 text-lg" />
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">客观公正</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        不站队、不偏袒，为所有当事人提供平等的发声机会。
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-100/70 rounded-2xl p-8 md:p-12 mt-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                  常见问题
                </h2>
                <script
                  type="application/ld+json"
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                      '@context': 'https://schema.org',
                      '@type': 'FAQPage',
                      mainEntity: [
                        {
                          '@type': 'Question',
                          name: '每日吃瓜的内容是否免费？',
                          acceptedAnswer: {
                            '@type': 'Answer',
                            text: '是的，每日吃瓜所有内容完全免费。作为免费吃瓜官网入口，我们坚持为吃瓜群众提供零门槛的娱乐资讯服务。',
                          },
                        },
                        {
                          '@type': 'Question',
                          name: '每日吃瓜的内容更新频率如何？',
                          acceptedAnswer: {
                            '@type': 'Answer',
                            text: '每日吃瓜坚持每日更新不打烊，365天全年无休。我们的编辑团队实时追踪娱乐圈动态，确保第一时间为读者带来最新爆料。',
                          },
                        },
                        {
                          '@type': 'Question',
                          name: '如何向每日吃瓜提供爆料线索？',
                          acceptedAnswer: {
                            '@type': 'Answer',
                            text: '您可以通过联系我们页面提供的邮箱发送爆料线索。我们承诺严格保护爆料人的隐私安全，绝不透露任何信息来源。',
                          },
                        },
                        {
                          '@type': 'Question',
                          name: '每日吃瓜的报道是否真实可靠？',
                          acceptedAnswer: {
                            '@type': 'Answer',
                            text: '每一条爆料都经过我们编辑团队的多方核实。我们坚持真实性原则，拒绝传播未经证实的虚假信息。如发现不实内容，我们会第一时间更正并致歉。',
                          },
                        },
                      ],
                    }),
                  }}
                />

                <div className="space-y-6">
                  {[
                    {
                      q: '每日吃瓜的内容是否免费？',
                      a: '是的，每日吃瓜所有内容完全免费。作为免费吃瓜官网入口，我们坚持为吃瓜群众提供零门槛的娱乐资讯服务。',
                    },
                    {
                      q: '每日吃瓜的内容更新频率如何？',
                      a: '每日吃瓜坚持每日更新不打烊，365天全年无休。我们的编辑团队实时追踪娱乐圈动态，确保第一时间为读者带来最新爆料。',
                    },
                    {
                      q: '如何向每日吃瓜提供爆料线索？',
                      a: '您可以通过联系我们页面提供的邮箱发送爆料线索。我们承诺严格保护爆料人的隐私安全，绝不透露任何信息来源。',
                    },
                    {
                      q: '每日吃瓜的报道是否真实可靠？',
                      a: '每一条爆料都经过我们编辑团队的多方核实。我们坚持真实性原则，拒绝传播未经证实的虚假信息。如发现不实内容，我们会第一时间更正并致歉。',
                    },
                  ].map((faq, idx) => (
                    <details key={idx} className="group border border-background-200 rounded-lg">
                      <summary className="flex items-center justify-between p-4 cursor-pointer text-sm font-semibold text-foreground-900">
                        {faq.q}
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform" />
                      </summary>
                      <p className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                        {faq.a}
                      </p>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>

        <section className="flex flex-col lg:flex-row min-h-[450px]">
          <div className="lg:w-1/2 relative overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20office%20with%20team%20collaboration%2C%20warm%20lighting%2C%20creative%20workspace%2C%20editorial%20style%2C%20professional%20atmosphere%2C%20clean%20and%20minimal&width=800&height=600&seq=chigua-about-contact&orientation=landscape"
              alt="联系我们 - 每日吃瓜"
              title="联系我们 - 每日吃瓜"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute top-6 left-6">
              <span className="px-3 py-1 bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full whitespace-nowrap">
                商务合作
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-background-50 leading-tight">
                期待
                <br />
                你的
                <br />
                声音
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 py-14 md:py-20 bg-background-50">
            <div className="max-w-md text-center">
              <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 leading-tight mb-6">
                联系我们
              </h2>
              <div className="space-y-4 text-left mb-8">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-accent-700 text-lg" />
                  </span>
                  <div>
                    <p className="text-sm text-foreground-400">爆料与合作邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">tips@ryo7a.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-accent-700 text-lg" />
                  </span>
                  <div>
                    <p className="text-sm text-foreground-400">工作时间</p>
                    <p className="text-sm font-medium text-foreground-800">周一至周日 9:00 - 24:00</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-accent-700 text-lg" />
                  </span>
                  <div>
                    <p className="text-sm text-foreground-400">办公地址</p>
                    <p className="text-sm font-medium text-foreground-800">北京市朝阳区望京SOHO</p>
                  </div>
                </div>
              </div>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                返回首页
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
